export default "__VITE_ASSET__Bf07yzum__"